/**
 * Format a period key ("YYYY-MM") into a localized month label, e.g. "July" or
 * "July 2026" when the year differs from the current one. Purely presentational;
 * used for card headlines and the Profile entry.
 */
export function monthLabel(
  periodKey: string,
  locale = "en",
  now = new Date(),
): string {
  const [y, m] = periodKey.split("-").map(Number);
  if (!y || !m) return periodKey;
  const date = new Date(y, m - 1, 1);
  const sameYear = y === now.getFullYear();
  try {
    return new Intl.DateTimeFormat(locale, {
      month: "long",
      ...(sameYear ? {} : { year: "numeric" }),
    }).format(date);
  } catch {
    return periodKey;
  }
}
